import { makeAutoObservable } from 'mobx';

export type ToastVariant = 'success' | 'error' | 'info' | 'warning';
export type ToastCallback = (dismissed: boolean) => void;

export type ToastItem = {
	id: number;
	message: string;
	variant: ToastVariant;
	duration: number;
}

class ToastStore {
	private nextId = 1;
	queue: ToastItem[] = [];

	constructor() {
		makeAutoObservable(this);
	}

	show(message: string, variant: ToastVariant = 'info', duration = 10000) {
		if (!message) return;

		if (variant === 'error') {
			const activeToast = this.current;
			if (activeToast?.variant === 'error') {
				activeToast.message = `${activeToast.message}\n${message}`;
				return;
			}
		}

		if (variant !== 'error' && this.current?.variant === 'error') {
			this.dismissCurrent();
		}

		this.queue.push({
			id: this.nextId++,
			message,
			variant,
			duration
		});
	}

	get current(): ToastItem | undefined {
		return this.queue[0];
	}

	dismissCurrent() {
		if (!this.queue.length) return;
		this.queue.shift();
	}

	clear() {
		this.queue = [];
	}
}

export const toastStore = new ToastStore();